import { useTranslation } from "react-i18next";

import { MARQUE } from "@dozka/ui";
import { Button, Carte, EnTeteDePanneau } from "@/shared/ui";
import { ConnexionDirecte } from "./ConnexionDirecte";
import { ENTETE_ECRAN } from "./enteteEcran";
import { useSession } from "./useSession";

/** Sur cyrano.work, jamais la page WorkOS (sa marque est celle de Dozka, pour
 *  tout l'environnement) : les fournisseurs et le code e-mail, en direct. */
const CONNEXION_DIRECTE = MARQUE.id === "cyrano";

export function LoginScreen() {
  const { signIn, isLoading } = useSession();
  const { t } = useTranslation();

  return (
    <div className="flex h-full items-center justify-center overflow-y-auto bg-canvas px-4 py-8">
      <div className="w-full max-w-[440px]">
        <Carte remplissage="lg" className="sm:p-10">
          <div className="mb-8 flex flex-col items-center gap-5 text-center">
            {MARQUE.logo ? (
              // Le wordmark de la marque dit déjà son nom : le titre ne reste
              // que pour les lecteurs d'écran.
              <img src={MARQUE.logo} alt={MARQUE.nom} className="h-12 w-auto max-w-full" />
            ) : (
              <img src={MARQUE.iconeConnexion} alt="" aria-hidden="true" className="h-16 w-16" />
            )}
            {MARQUE.logo ? (
              <>
                <h1 className="sr-only">{MARQUE.id === "dozka" ? t("auth.appName") : MARQUE.nom}</h1>
                <p className="text-[15px] text-muted">{t("auth.loginPrompt")}</p>
              </>
            ) : (
              <EnTeteDePanneau
                titre={MARQUE.id === "dozka" ? t("auth.appName") : MARQUE.nom}
                sousTitre={t("auth.loginPrompt")}
                className={ENTETE_ECRAN}
              />
            )}
          </div>
          {CONNEXION_DIRECTE ? (
            <ConnexionDirecte />
          ) : (
            <>
              <Button
                variant="accent"
                size="xl"
                onClick={() => signIn()}
                disabled={isLoading}
                className="w-full"
              >
                {isLoading ? t("auth.signingIn") : t("auth.signIn")}
              </Button>
              <p className="mt-6 text-center text-[12.5px] text-faint">{t("auth.footer")}</p>
            </>
          )}
        </Carte>
      </div>
    </div>
  );
}
